import * as versions from './mutation-types'
import axios from 'axios'

/**
 * Get client service versions
 *
 * @param commit
 */
export const getServiceVersions = async ({ commit }, serviceName) => {
  try {
    const serviceVersionsResponse = await axios.get(`/api/v1/service_versions/${serviceName}`)
    var filteredVersions = serviceVersionsResponse.data['service_versions']
      .reduce(function (serviceVersionIdsMap, nextItem) {
        // build up key-value pairs of service versions ids to the service version object returned in the response
        if (serviceVersionIdsMap[nextItem.id] === undefined) {
          // add that object to the service Versions map
          serviceVersionIdsMap[nextItem.id] = nextItem
        }
        return serviceVersionIdsMap
      }, {})
    commit(versions.FETCH_CLIENT_SERVICE_VERSIONS, filteredVersions)
    return filteredVersions
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const setDefaultServiceVersions = async ({ commit }, serviceDict) => {
  try {
    serviceDict['service_version'].is_default = true
    const response = await axios.put(`/api/v1/service_versions/${serviceDict['service_name']}`, serviceDict['service_version'])
    commit(versions.SET_DEFAULT_SERVICE_VERSION, response)
    let updated = await getServiceVersions({ commit }, serviceDict.service_name)
    return updated
  } catch (err) {
    console.error(err)
    throw err
  }
}

export default {
  getServiceVersions,
  setDefaultServiceVersions
}
